
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { useI18n } from "vue-i18n";

declare var require: any;
export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  computed: { ...mapState(["currentSlide", "config"]) },
});
